const copy = function copyText(selector, text, isHtml) {
  const el = document.querySelector(selector)
  if (!el) {
    return
  }

  handleCopy(el, text, isHtml)
  setSelection(el)
}

function setSelection(el) {
  let selection
  let range
  el.setAttribute('contenteditable', true)
  if (isFormElement(el)) {
    el.select()
  } else {
    range = document.createRange()
    const end = el.childNodes.length
    range.setStart(el, 0)
    range.setEnd(el, end)

    selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }
  document.execCommand('copy', false, null)
  range && selection.removeRange ? selection.removeRange(range) : selection.removeAllRanges()
}

function handleCopy(el, text, isHtml) {
  const copyEvent = function(e) {
    if (!isFormElement(el)) {
      let oldText = isHtml ? el.outerHTML + '\n' : el.innerText
      oldText = text ? oldText + text : oldText
      e.clipboardData.setData('text/plain', oldText.trim())
      e.preventDefault()
    }

    setTimeout(function() {
      el.removeAttribute('contenteditable', true)
      el.removeEventListener('copy', copyEvent)
    }, 0)
  }

  el.addEventListener('copy', copyEvent)
}

function isFormElement(el) {
  return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement
}

export default copy
